/* eslint-disable eqeqeq */
import Vue from 'vue'
import spinnerBox from '@/integrations/liveperson/spinnerBox'
import '@/integrations/liveperson/styles.styl'

export default ({ $config, $integrationsManager, $uiEvents }) => {
    const siteId = $config.runtime.integrations.liveperson.siteId
    const stickyEnagagmentId = $config.runtime.integrations.liveperson.engagementId
    let stickyDomId = ''
    let proactiveDomId = ''
    let chatWindowActivity = false

    window.lpTag = window.lpTag || {}

    const forceLoadChat = $integrationsManager.loaders.onNuxtReadyLoader(() => {
        // prettier-ignore
        // eslint-disable-next-line
        'undefined'==typeof window.lpTag._tagCount?(window.lpTag={wl:lpTag.wl||null,scp:lpTag.scp||null,site:siteId||'',section:lpTag.section||'',tagletSection:lpTag.tagletSection||null,autoStart:lpTag.autoStart!==!1,ovr:lpTag.ovr||{},_v:'1.10.0',_tagCount:1,protocol:'https:',events:{bind:function(t,e,i){lpTag.defer(function(){lpTag.events.bind(t,e,i)},0)},trigger:function(t,e,i){lpTag.defer(function(){lpTag.events.trigger(t,e,i)},1)}},defer:function(t,e){0===e?(this._defB=this._defB||[],this._defB.push(t)):1===e?(this._defT=this._defT||[],this._defT.push(t)):(this._defL=this._defL||[],this._defL.push(t))},load:function(t,e,i){var n=this;setTimeout(function(){n._load(t,e,i)},0)},_load:function(t,e,i){var n=t;t||(n=this.protocol+'//'+(this.ovr&&this.ovr.domain?this.ovr.domain:'lptag.liveperson.net')+'/tag/tag.js?site='+this.site);var o=document.createElement('script');o.setAttribute('charset',e?e:'UTF-8'),i&&o.setAttribute('id',i),o.setAttribute('src',n),document.getElementsByTagName('head').item(0).appendChild(o)},init:function(){this._timing=this._timing||{},this._timing.start=(new Date).getTime();var t=this;window.attachEvent?window.attachEvent('onload',function(){t._domReady('domReady')}):(window.addEventListener('DOMContentLoaded',function(){t._domReady('contReady')},!1),window.addEventListener('load',function(){t._domReady('domReady')},!1)),'undefined'===typeof window._lptStop&&this.load()},start:function(){this.autoStart=!0},_domReady:function(t){this.isDom||(this.isDom=!0,this.events.trigger('LPT','DOM_READY',{t:t})),this._timing[t]=(new Date).getTime()},vars:lpTag.vars||[],dbs:lpTag.dbs||[],ctn:lpTag.ctn||[],sdes:lpTag.sdes||[],hooks:lpTag.hooks||[],identities:lpTag.identities||[],ev:lpTag.ev||[]},lpTag.init()):window.lpTag._tagCount+=1;

        // listen to their widgets trigger
        window.lpTag.events.bind({
            eventName: 'OFFER_DISPLAY',
            appName: 'LP_OFFERS',
            func(data) {
                if (data.engagementId == stickyEnagagmentId)
                    stickyDomId = document.querySelector('.LPMcontainer[role="button"]').id
                else
                    proactiveDomId = document.querySelector('.LPMcontainer:not([role="button"])').id
            },
        })

        window.lpTag.events.bind({
            eventName: 'OFFER_CLICK',
            appName: 'LP_OFFERS',
            func() {
                // default sticky widget doesn't auto-close when clicked, no idea why
                if (stickyDomId) updateWidgetDisplay(stickyDomId, 'none')
            },
        })

        // we have to keep track of if chat window shows (which it does sometimes when you enter chat, then come back)
        window.lpTag.events.bind({
            eventName: 'conversationInfo',
            appName: 'lpUnifiedWindow',
            func(data) {
                chatWindowActivity = true
            },
        })
    }, 15000)

    // so lp knows what the new url is
    $uiEvents.$on('routeChanged', () => {
        // pretty much not documented anywhere
        if (window.lpTag.newPage) window.lpTag.newPage(document.URL)
    })

    function updateWidgetDisplay(id, display) {
        const el = document.getElementById(id)
        if (el) el.style.display = display
    }

    // https://forum.vuejs.org/t/add-component-to-dom-programatically/7308/3
    // https://css-tricks.com/creating-vue-js-component-instances-programmatically/
    function showSpinnerBox() {
        const instance = new Vue(Object.assign({}, spinnerBox))
        const spinnerBoxRef = instance.$mount()
        document.body.appendChild(instance.$el)

        let checkCount = 0
        // have to worry about if chat window is auto opened
        const checker = setInterval(() => {
            checkCount++

            // we give up
            if (checkCount > 120) destroySpinnerBox()

            // kill spinner if an engagement finally shows up, or when a chat window auto-pops up on it's own
            if (
                (window.lpTag.taglets &&
                    window.lpTag.taglets.rendererStub &&
                    window.lpTag.taglets.rendererStub.getEngagementInfo(stickyEnagagmentId)
                        .engagementId == stickyEnagagmentId) ||
                chatWindowActivity
            ) {
                showChatWindow()
                destroySpinnerBox()
            }
        }, 500)

        // local helper
        function destroySpinnerBox() {
            clearInterval(checker)
            spinnerBoxRef.$destroy()

            try {
                spinnerBoxRef.$el.remove()
            } catch (error) {
                // IE 11 sucks
                spinnerBoxRef.$el.style.display = 'none'
            }
        }
    }

    function showChatWindow() {
        if (!window.lpTag.taglets || !window.lpTag.taglets.rendererStub) return

        window.lpTag.taglets.rendererStub.click(stickyEnagagmentId)

        // hide all bubbles
        if (proactiveDomId) updateWidgetDisplay(proactiveDomId, 'none')

        updateWidgetDisplay(stickyDomId, 'none')
    }

    return {
        open() {
            // lp isn't ready, show a spinner
            if (!window.lpTag.taglets || !window.lpTag.taglets.rendererStub) {
                forceLoadChat()
                showSpinnerBox()
                return
            }

            showChatWindow()
        },
    }
}
